/**
 * Переключатель ширины панели контента (узкий / широкий).
 *
 * Класс `content-narrow` вешается на #content-area, поэтому сохраняется при
 * AJAX-подгрузке страниц. Выбор хранится в localStorage ('contentWidth').
 */
document.addEventListener('DOMContentLoaded', function () {
  const contentArea = document.getElementById('content-area');
  const toggle = document.getElementById('content-width-toggle');
  if (!contentArea || !toggle) return;

  const KEY = 'contentWidth';
  const NARROW = 'narrow';

  function apply(mode) {
    const narrow = mode === NARROW;
    contentArea.classList.toggle('content-narrow', narrow);
    toggle.textContent = narrow ? 'Узкий' : 'Широкий';
    toggle.setAttribute('aria-pressed', narrow ? 'true' : 'false');
  }

  function storedMode() {
    try {
      return localStorage.getItem(KEY) === NARROW ? NARROW : 'wide';
    } catch (e) {
      return 'wide';
    }
  }

  let mode = storedMode();
  apply(mode);

  toggle.addEventListener('click', function () {
    mode = mode === NARROW ? 'wide' : NARROW;
    try { localStorage.setItem(KEY, mode); } catch (e) { /* ignore */ }
    apply(mode);
  });
});
